import React from 'react';
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import "./profile.scss"

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';
import checkGreen from './../../assets/images/icons/radio-button-green.png';
import checkWhite from './../../assets/images/icons/radio-button-wwhite.png';

import { Button } from 'react-onsenui';
import Modal from '@mui/material/Modal';

import packageJson from '../../../package.json';
class SystemSettingScreen extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isModal: false,
			lan_: localStorage.getItem("language"),
		}
	}

	Logout() {
		localStorage.clear();
		window.location.reload(false);
	}

	changeLanguage() {
		var self = this;
		if (self.state.lan_) {
			strings.setLanguage(self.state.lan_);
			localStorage.setItem("language", self.state.lan_);
			self.setState({ isModal: false, });
		}
	}

	closeModal() {
		this.setState({
			isModal: false,
		});
	}

	render() {
		return (
			<SubLayout data={{ "title": strings.system_setting }}>
				<div className="profile-subpage">
					<div className='profile-panel'>
						<div onClick={() => this.setState({ isModal: true })} className='profile-list-item' style={{ cursor: 'pointer' }}>
							<div className='profile-list-left'>
								<span>{strings.language}</span>
							</div>
							<div className='profile-list-right'>
								<span>
									{(this.state.lan_ == 'en') ? strings.english : ''}
									{(this.state.lan_ == 'zh') ? strings.chinese : ''}
								</span>
								<img src={ArrowForword} alt="ArrowForword"></img>
							</div>
						</div>
						<div className='profile-list-item'>
							<div className='profile-list-left'>
								<span>{strings.firmware_version}</span>
							</div>
							<div className='profile-list-right'>
								<span>V {packageJson.version}</span>
							</div>
						</div>
					</div>

					<div className='profile-form-card' style={{ marginTop: 14 }}>
						<Button onClick={() => this.Logout()} className='btn rounded-sm btn-m text-uppercase font-700 btn-full profile-submit-btn'>
							{strings.logout}
						</Button>
					</div>
				</div>

				<Modal
					open={this.state.isModal ?? false}
					className="itemModal"
					onClose={() => this.closeModal()}
					style={{ overflow: 'scroll' }}
				>
					<>
						<div className="modal-dialog modal-dialog-centered modal-sm">
							<div className="modal-content">
								<div className="modal-header" style={{ width: "100%" }}>
									<span style={{ color: "#FFF" }}>{strings.language}</span>
									<button onClick={() => this.closeModal()}
										type="button" className="close" data-dismiss="modal" aria-label="Close"
										style={{ background: "transparent", borderWidth: 0 }}
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div className="modal-body">
									<div>
										<div onClick={() => this.setState({ lan_: "en" })} className='profile-list-item' style={{ cursor: 'pointer' }}>
											<div className='profile-list-left'>
												{(this.state.lan_ == 'en') ?
													<img src={checkGreen} alt="en" width="20" />
													:
													<img src={checkWhite} alt="en" width="20" />
												}
												<span>{strings.english}</span>
											</div>
										</div>
										<div onClick={() => this.setState({ lan_: "zh" })} className='profile-list-item' style={{ cursor: 'pointer' }}>
											<div className='profile-list-left'>
												{(this.state.lan_ == 'zh') ?
													<img src={checkGreen} alt="zh" width="20" />
													:
													<img src={checkWhite} alt="zh" width="20" />
												}
												<span>{strings.chinese}</span>
											</div>
										</div>
									</div>
									<div className='text-center' style={{ marginTop: 12 }}>
										<Button onClick={() => this.changeLanguage()} className='btn rounded-sm btn-m text-uppercase font-700 btn-full profile-submit-btn'>
											{strings.save}
										</Button>
									</div>
								</div>
							</div>
						</div>
					</>
				</Modal>
			</SubLayout >
		);
	}
}

export default SystemSettingScreen;
